module.exports = __webpack_public_path__ + "static/media/6. Rendy.ee230745.png";